<mat-form-field appearance="outline" class="w-100 custom-date">
  <mat-label class="fs-14">{{ placeholder }}</mat-label>

  <mat-date-range-input [formGroup]="formGroup" [max]="maxDate" [min]="minDate" [rangePicker]="rangePicker">
    <input matStartDate formControlName="start" placeholder="{{ 'eventForm.labels.startDate' | translate }}" />
    <input matEndDate formControlName="end" placeholder="{{ 'eventForm.labels.endDate' | translate }}" />
  </mat-date-range-input>

  <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>

  <mat-date-range-picker #rangePicker>
    <mat-date-range-picker-actions>
      <button
        class="btn rounded-1 fs-14 btn-outline-primary w-50 fw-bold white-space-nowrap"
        mat-button
        matDateRangePickerCancel
        (click)="onReset()"
      >
        {{ 'common.reset' | translate }}
      </button>
      <button
        class="btn rounded-1 fs-14 btn-outline-primary w-50 fw-bold white-space-nowrap"
        mat-raised-button
        matDateRangePickerApply
      >
        {{ 'common.done' | translate }}
      </button>
    </mat-date-range-picker-actions>
  </mat-date-range-picker>
</mat-form-field>
